import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LkpRevenueModel } from 'src/app/models/LkpRevenueModel';
import { LkpRevenueService } from 'src/app/services/LkpRevenueService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-revenue-types-search',
  templateUrl: './revenue-types-search.component.html',
  styleUrls: ['./revenue-types-search.component.css']
})
export class RevenueTypesSearchComponent implements OnInit {
  revcode = '' ;
  revname = '' ;
  revnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

  revenueList: LkpRevenueModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public revenueservice : LkpRevenueService,
              public storage: LocalStorageService,
              public lkprevenue : LkpRevenueModel,
              public dialogRef: MatDialogRef<RevenueTypesSearchComponent>,) { }

  ngOnInit(): void {
    this.retriveRevenueLookupTop();
  }
  retriveRevenueLookupTop(){
    this.revenueList = [];
    this.revenueservice.getRevenueLookupTop(this.storage.retrieve('stgcompcode')).subscribe((data: LkpRevenueModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.revenueList[i] = data[i];
      }
  });
 }
  retriveRvenueLookup(){

  }
  SelectRevenue(Rom : LkpRevenueModel){
    this.lkprevenue.revcode = Rom.revcode
    this.lkprevenue.revname = Rom.revname
    this.lkprevenue.revnotes= Rom.revnotes

    this.lkprevenue.userid = Rom.userid
    this.lkprevenue.modifieddate = Rom.modifieddate
    this.lkprevenue.compcode = Rom.compcode
    this.submitClicked.emit(this.lkprevenue);
    this.dialogRef.close();
  }
}
